import Component from 'vue-class-component'
import ContainerVue from './Container'
import { NORTH, SOUTH } from './Droppable'
import { ColumnsData } from '../../store/editor/components/state'
import InteractableComponent from './InteractableComponent'
import { Actions } from '../../store/editor/components/helpers'
import ColumnSeparatorVue from './ColumnSeparator.vue'

@Component({
  components: {
    'column-separator': ColumnSeparatorVue
  }
})
export default class ColumnsVue extends ContainerVue<ColumnsData> {
  private interactable: InteractableComponent

  get itemSizes(): number[] {
    return this.componentData.itemSizes
  }

  mounted() {
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.droppable({
      directions: [NORTH, SOUTH]
    })
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed() {
    this.interactable.destroy()
  }

  getColumnWidthStyle(index: number): string {
    if (this.itemSizes && this.itemSizes.length > index) {
      const size = this.itemSizes[index]
      return `column-width--${size}`
    }
    return ''
  }

  updateItemSizes(itemSizes: number[]): void {
    this.save(Object.assign({}, this.componentData, <ColumnsData>{
      itemSizes
    }))
  }
}
